export default "__VITE_ASSET__D42Lm5oi__"